import { render } from "./TourGuideForm.vue?vue&type=template&id=6d785486&scoped=true"
import script from "./TourGuideForm.vue?vue&type=script&lang=js"
export * from "./TourGuideForm.vue?vue&type=script&lang=js"

import "./TourGuideForm.vue?vue&type=style&index=0&id=6d785486&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6d785486"

export default script